import { getHeaders } from 'auth/auth';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../baseQuery';

//admin API'S

export const loanInformationAPI = createApi({
  reducerPath: 'loanInformation',
  tagTypes: ['updateLoanInfo'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    // List/search employees (replaces leads/dashboard APIs)
    getAllEmployees: builder.query({
      query: ({ page_number = 1, page_size = 10, search = '', role = '' }) => {
        let url = `/b2b/loan/employee/?page_number=${page_number}&page_size=${page_size}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        if (role) url += `&role=${encodeURIComponent(role)}`;
        return {
          url,
          method: 'GET',
          headers: getHeaders(),
        };
      },
      providesTags: ['updateLoanInfo'],
    }),
    // Delete employee
    deleteEmployee: builder.mutation({
      query: (user_id) => ({
        url: `/b2b/loan/employee/${user_id}`,
        method: 'DELETE',
        headers: getHeaders(),
      }),
      invalidatesTags: ['updateLoanInfo'],
    }),
  }),
});

export const {
  useGetAllEmployeesQuery,
  useDeleteEmployeeMutation,
} = loanInformationAPI;
